module.exports = __webpack_public_path__ + "img/logo-hauseful-checklist.6d124b94.svg";